import React from 'react'

import Page from '@components/Page'
import Filters from '@components/Filters'
import FilterToggle from '@components/Filter/FilterToggle'
import Entries from '@components/Entries'

import { useHomeData } from './useHomeData'

import styles from './styles.module.css'

const Home = () => {
  const { entries, error, hasMoreEntries, isLoading, isValidating, observerRef } = useHomeData()

  return (
    <Page className={styles.home}>
      <Page.Header>
        <FilterToggle />
      </Page.Header>

      <Page.Aside>
        <Filters />
      </Page.Aside>

      <Page.Main>
        <Page.AsyncContent
          isError={!!error}
          errorFallback={<p>{error?.message ?? ''}</p>}
          isLoading={isLoading}
          loadingFallback='Loading Media'
          observerRef={observerRef}
        >
          <Entries entries={entries} isLoadingMore={hasMoreEntries && isValidating} />
        </Page.AsyncContent>
      </Page.Main>
    </Page>
  )
}

export default Home
